import CookieRepository from '../../Infrastructure/Repositories/CookieRepository';
import LocalStorageRepository from '../../Infrastructure/Repositories/LocalStorageRepository';
import SSRNoOpRepository from '../../Infrastructure/Repositories/SSRNoOpRepository';
import SessionStorageRepository from '../../Infrastructure/Repositories/SessionStorageRepository';
const StorageRepositoryFactory = {
  resolve(context, storageUseCaseConfig) {
    if (context.drivers.platformService.isServerSideRendering()) {
      return new SSRNoOpRepository();
    }
    switch (storageUseCaseConfig.implementation) {
      case 'cookie':
        return new CookieRepository(context.drivers.cookieService);
      case 'local-storage':
        return new LocalStorageRepository();
      case 'session-storage':
        return new SessionStorageRepository();
      default:
        throw new Error('StorageRepositoryFactory not present in configuration');
    }
  }
};
export default StorageRepositoryFactory;
